import { useCompassLayoutsGetFlagOrganizationQuery } from "./graphql/CompassLayoutsGetFlagOrganization.v4.b2b.generated";
var useFlagOrganization = function useFlagOrganization(_ref) {
  var _data$b2bOrganization, _data$b2bOrganization2;
  var flag = _ref.flag,
    organizationSlug = _ref.organizationSlug;
  var _useCompassLayoutsGet = useCompassLayoutsGetFlagOrganizationQuery({
      variables: {
        slug: organizationSlug
      },
      context: {
        clientName: 'v4.b2b'
      },
      fetchPolicy: 'network-only',
      skip: !organizationSlug
    }),
    data = _useCompassLayoutsGet.data,
    loading = _useCompassLayoutsGet.loading;
  var currentFlag = data === null || data === void 0 ? void 0 : (_data$b2bOrganization = data.b2bOrganizationCurrent) === null || _data$b2bOrganization === void 0 ? void 0 : (_data$b2bOrganization2 = _data$b2bOrganization.features) === null || _data$b2bOrganization2 === void 0 ? void 0 : _data$b2bOrganization2.find(function (feature) {
    return (feature === null || feature === void 0 ? void 0 : feature.slug) === flag;
  });
  return {
    isActive: (currentFlag === null || currentFlag === void 0 ? void 0 : currentFlag.isActive) || false,
    isLoading: loading
  };
};
export default useFlagOrganization;